import { render, staticRenderFns } from "./CalcOfertaLinea.vue?vue&type=template&id=827ff1fe&scoped=true"
import script from "./CalcOfertaLinea.vue?vue&type=script&lang=js"
export * from "./CalcOfertaLinea.vue?vue&type=script&lang=js"
import style0 from "./CalcOfertaLinea.vue?vue&type=style&index=0&id=827ff1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827ff1fe",
  null
  
)

export default component.exports